<template>
  <div>
    <v-select
      v-model="state.componenteData.opcaoSelecionada"
      dense
      outlined
      no-data-text="Nenhum item registrado"
      item-text="nome"
      item-value="id"
      hide-details
      :label="label"
      :filled="filled"
      :disabled="disabled"
      :readonly="readonly"
      :items="opcoes"
      :rules="[(obrigatorio && !readonly ? val => !!val || 'Este campo é obrigatório' : true)]"
      @change="handleDropdownListEncadeadoChange(state.componenteData, $event)"
      @input="v => $emit('adicionar-formulario-resposta', { selecionado: state.componenteData.opcaoSelecionada, id: state.componenteData.id })"
    >
      <template
        v-if="mostrarIcones"
        v-slot:prepend
      >
        <icons
          :is-configurar-celula-dialog-open="isConfigurarCelulaDialogOpen"
          :is-deletar-componente-dialog-open="isDeletarComponenteDialogOpen"
          @update:is-configurar-celula-dialog-open="v => $emit('update:is-configurar-celula-dialog-open', v)"
          @update:is-deletar-componente-dialog-open="v => $emit('update:is-deletar-componente-dialog-open', v)"
        />
      </template>
    </v-select>

    <v-select
      v-for="(encadeado, index) in encadeados"
      :key="encadeado.id"
      v-model="encadeado.opcaoSelecionada"
      class="mt-2"
      dense
      outlined
      no-data-text="Nenhum item registrado"
      item-text="nome"
      item-value="id"
      hide-details
      :label="encadeado.label"
      :filled="filled"
      :disabled="disabled"
      :readonly="readonly"
      :items="filtrarOpcoes(encadeado, index)"
      :rules="[(encadeado.obrigatorio && !readonly ? val => !!val || 'Este campo é obrigatório' : true)]"
      @change="handleDropdownListChange(encadeado, $event, index)"
      @input="v => $emit('adicionar-formulario-resposta', { selecionado: encadeado.opcaoSelecionada, id: encadeado.id })"
    >
      <template
        v-if="mostrarIcones"
        v-slot:prepend
      >
        <v-icon
          color="accent"
          class="pl-4 pr-3"
        >
          {{ icons.mdiLinkVariant }}
        </v-icon>
      </template>
    </v-select>
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { mdiLinkVariant } from '@mdi/js'
import Componente from '@/models/entities/formulario/componente/Componente'
import Icons from './Icons.vue'
import TiposDeComponentesEnum from '@/models/entities/formulario/componente/TiposDeComponentesEnum'
import ComponenteBase from './ComponenteBase.vue'
import selectableComponentMixin from '@/mixins/selectableComponentMixin'

export default {
  components: {
    Icons,
  },

  extends: ComponenteBase,

  mixins: [selectableComponentMixin],

  setup(props, { emit }) {
    const state = ref({})
    const encadeados = ref([])

    function setOpcaoSelecionda(item) {
      const tamanho = item.ticketsRespostas.length
      const idResposta = item.ticketsRespostas[tamanho - 1]

      return idResposta ? idResposta.idFormularioElementoOpcaoResposta : 0
    }

    function setData(value) {
      state.value = { componenteData: value, opcaoSelecionada: 0 }
      encadeados.value = Componente.listarComponentesEncadeados(state.value.componenteData.elementoEncadeado)

      state.value.componenteData.opcaoSelecionada = setOpcaoSelecionda(state.value.componenteData)

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < encadeados.value.length; i++) {
        encadeados.value[i].opcaoSelecionada = setOpcaoSelecionda(encadeados.value[i])
      }
    }
    watch(() => props.componenteData, setData, { immediate: true, deep: true })

    function filtrarOpcoes(encadeado, index) {
      const encadeadoPai = index === 0 ? state.value.componenteData : encadeados.value[index - 1]
      return !encadeadoPai.opcaoSelecionada ? [] : encadeado.opcoes.filter(op => op.idOpcaoPai === encadeadoPai.opcaoSelecionada)
    }

    function resetarSelectsSubsequentes(elemento, index) {
      if (elemento.idElementoPai === null) {
        encadeados.value = encadeados.value.map(it => ({ ...it, opcaoSelecionada: 0 }))
      } else {
        encadeados.value = encadeados.value.map((it, ind) => (ind > index ? { ...it, opcaoSelecionada: 0 } : it))
      }
    }

    function handleDropdownListEncadeadoChange(obj, value) {
      resetarSelectsSubsequentes(obj)
      emit('input-changed', { value, componenteId: obj.id, componenteTipoId: TiposDeComponentesEnum.DropDownListEncadeado, label: obj.label })
    }

    function handleDropdownListChange(obj, value, index) {
      resetarSelectsSubsequentes(obj, index)
      emit('input-changed', { value, componenteId: obj.id, componenteTipoId: TiposDeComponentesEnum.DropDownList, label: obj.label })
    }

    return {
      state,
      encadeados,
      filtrarOpcoes,
      resetarSelectsSubsequentes,
      handleDropdownListEncadeadoChange,
      handleDropdownListChange,
      icons: {
        mdiLinkVariant,
      },
      TiposDeComponentesEnum,
    }
  },
}
</script>
